import { DayTimelineRange } from "./DayTimelineRange.js";
import { clockRangeFromInstance, clockRangeFromRRule } from "./day-timeline-range-source.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/RRule/DayTimelineRangeDisplay.tsx
function isInstanceRange(props) {
	return "startsAt" in props;
}
function DayTimelineRangeDisplay(props) {
	const range = isInstanceRange(props) ? clockRangeFromInstance({
		endsAt: props.endsAt,
		startsAt: props.startsAt
	}, props.timezone) : clockRangeFromRRule(props.rrule, props.durationMin);
	return /* @__PURE__ */ jsx(DayTimelineRange, {
		durationMin: range.durationMin,
		fromMin: range.fromMin,
		lanes: props.lanes,
		toMin: range.toMin
	});
}
//#endregion
export { DayTimelineRangeDisplay };

//# sourceMappingURL=DayTimelineRangeDisplay.js.map